import { IFieldDef } from "@components/smart/FieldInfo";
import { IFetchDataArgs } from "@components/smart/smartTable";
import { IColumn, IRow, IRowValues } from "@components/table/Table.types";
import TableWithAutoSizedColumns from "@components/table/TableWithAutoSizedColumns";
import { IEntity } from "@odata/BindingContext";
import { getNestedValue } from "@odata/Data.utils";
import customFetch from "@utils/customFetch";
import { getOneFetch } from "@utils/oneFetch";
import React from "react";

import { TValue } from "../../global.types";
import { FormStorage } from "../../views/formView/FormStorage";

interface IProps {
    endPoint: string;
    storage: FormStorage;
    columns: IFieldDef[];
}

interface IState {
    rows: IRow[];
    loaded: boolean;
}

const oneFetch = getOneFetch();

export class TableWithEndpoint extends React.Component<IProps, IState> {
    state = {
        loaded: false,
        rows: [] as IRow[]
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData(): Promise<void> {
        const response = await customFetch(this.props.endPoint);
        if (!response.ok) {
            this.setState({
                loaded: true,
                rows: []
            });

            return;
        }

        const data = await response.json() as IEntity;
        this.prepareRows(data?.value);
    }

    getColumns = (): IColumn[] => {
        return this.props.columns.map(column => ({
            id: column.id,
            textAlign: column.textAlign,
            label: column.label
        }));
    };


    prepareRows = (data: IEntity[]) => {
        const rows: IRow[] = [];
        let i = 0;
        for (const row of data || []) {
            const rowValues: IRowValues = {};
            for (const column of this.props.columns) {
                const directValue = column.fieldSettings?.displayName ? getNestedValue(column.fieldSettings?.displayName, row[column.id]) : row[column.id];
                const value: TValue = column.formatter ?
                    column.formatter(directValue, {
                        item: row,
                        storage: this.props.storage,
                    }) : directValue;

                rowValues[column.id] = value as string;
            }

            rows.push({
                id: i++,
                values: rowValues
            });
        }

        this.setState({ rows, loaded: true });
    }

    render() {
        if (!this.state.loaded) {
            return null;
        }

        return <TableWithAutoSizedColumns
            disableVirtualization={true}
            disableSort={true}
            columns={this.getColumns()}
            rows={this.state.rows}/>;
    }
}